export default __webpack_public_path__ + "static/N0045-790cfac80b31fe860259452b0133d2be.png";